import { Route, Switch } from "react-router-dom";
import ModalWindow from "../ModalWindow/ModalWindow";
import SignInForm from "../SignInForm/SignInForm";
import { routes } from "../../routes";
import SignUpForm from "../SignUpForm/SignUpForm";
import BookingForm from "../BookingForm/BookingForm";
import BookingCompletedForm from "../BookingCompletedForm/BookingCompletedForm";

const WindowShower = () => {
  return (
    <Switch>
      <Route path={routes.signIn}>
        <ModalWindow show>
          <SignInForm />
        </ModalWindow>
      </Route>
      <Route path={routes.signUp}>
        <ModalWindow show>
          <SignUpForm />
        </ModalWindow>
      </Route>
      <Route path={routes.booking}>
        <ModalWindow show>
          <BookingForm />
        </ModalWindow>
      </Route>
      <Route path={routes.bookingCompleted}>
        <ModalWindow show>
          <BookingCompletedForm />
        </ModalWindow>
      </Route>
    </Switch>
  );
};

export default WindowShower;
